import React from 'react';
import { Form, Switch } from 'antd';

class SwitchButton extends React.Component {
    render() {
        const { getFieldDecorator } = this.props.form;
        let labelPosition = (this.props.labelCol || this.props.wrapperCol) ? {
            labelCol: this.props.labelCol,
            wrapperCol: this.props.wrapperCol
        } : null;
        return (
            <Form.Item label={this.props.labeltext} className={this.props.className} {...labelPosition}>
                {getFieldDecorator(this.props.datafield, { valuePropName: 'checked', initialValue: this.props.defaultChecked })(
                    <Switch checkedChildren="Yes" unCheckedChildren="No" disabled={this.props.disabled} onChange={this.props.onChange} checked={this.props.checked} />
                )}
            </Form.Item>
        )
    }
}
export default SwitchButton;